import React from 'react';
import styled from 'styled-components';

import { Container, Section } from '../Blocks';


const PrivacyWrapper = styled.div`
  h1 {
    margin-bottom: 42px;
  }
  h3 {
  color: ${(props) => props.theme.brand};
  margin-bottom: 0px;
  font-size: 2rem;
  }`;


const PagePrivacy = ({ privacyContenuto }) => (
  <Section
    padding="136px 10px 60px"
    paddingmobile="96px 20px 40px"
  >
    <Container>
      <PrivacyWrapper dangerouslySetInnerHTML={{ __html: privacyContenuto }} />
    </Container>
  </Section>
);

export default PagePrivacy;
